import React from "react";

import Section from "../components/Section";
import DOMPurify from 'dompurify'
import Teaser from "../components/Teaser";
import ClubFinder from "../components/ClubFinder";
import Slider from "../components/Slider";
import Button from "../components/common/Button";
import Picture from "../components/common/Picture";
import Heading from "../components/common/Heading";
// import Image from '../components/common/Image';
import SliderItem from "../components/SliderItem";
import SliderItemMember from "../components/SliderItemMember";
import SliderItemCite from "../components/SliderItemCite";
import BackgroundImageBox from "../components/BackgroundImageBox";

import { EnvContext } from "../context/env-context";

import parseSources from "../utilities/parseSources";

class PageStart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      data: {},
      lang: document.documentElement.lang.split("-")[0],
    };
  }

  componentDidMount() {
    let url = null,
        headers = {};
    if (this.context === "local") {
      url = "/startpage.json";
      headers = {
        Authorization: `Basic ${btoa("staging:*Staging21%")}`,
      };
    } else if (this.context === "staging") {
      url = "https://staging.puregym.swiss/wp-json/startpage/v1/info/";
      headers = {
        Authorization: `Basic ${btoa("staging:*Staging21%")}`,
      };
    } else if (this.context === "production") {
      url = "/startpage.json";
      headers = {
        Authorization: `Basic ${btoa("staging:*Staging21%")}`,
      };
    }

    if (url) {
      fetch(url, {
        headers,
        mode: "cors",
      })
        .then((res) => res.json())
        .then(
          (result) => {
            this.setState({
              isLoaded: true,
              data: result,
            });
          },
          (error) => {
            this.setState({
              isLoaded: false,
              error,
            });
          }
        );
    }
  }

  render() {
    const lang = this.state.lang;

    const gridImages = this.state.isLoaded
      ? this.state.data.offers.images?.map((image) => {
          return parseSources(image);
        })
      : {};
    return (
      <>
        {/* <Section>
          {this.state.isLoaded && (
            <Intro data={this.state.data.header} lang={lang} />
          )}
        </Section> */}



        <Section className="tw-overflow-hidden pg-slider-top">
          {this.state.isLoaded && (
            <div className="tw-p-5 tw-max-w-screen-lg tw-m-auto">
              {/*<h2 className="tw-font-italic tw-font-black tw-text-2xl tw-uppercase tw-leading-7 lg:tw-mb-7">
                PureGym - <br />
                {this.state.data.news.title[lang]}
                </h2>*/}
              <Slider
                className="tw-pt-3 ipad:tw-hidden"
                viewportClassName="tw-overflow-visible"
                innerClassName="tw-space-x-2"
                // spacerClassName="w-3"
              >
                {this.state.data.news.items.map((props, index) => {
                  return (
                    <SliderItem
                      key={"slider_item_" + index}
                      {...props}
                      sliderBG={index}
                      lang={lang}
                    />
                  );
                })}
              </Slider>
              <div className="tw-hidden ipad:tw-flex ipad:tw-gap-2">
                {this.state.data.news.items.map((props, index) => {
                  return (
                    <SliderItem
                      className="ipad:tw-flex-1"
                      key={"slider_item_" + index}
                      {...props}
                      sliderBG={index}
                      lang={lang}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </Section>

        <Section className="tw-overflow-hidden">
            
            {(this.state.isLoaded && this.state.data.membership.items[lang]) && (
              <div className="tw-p-5 tw-max-w-screen-lg tw-m-auto">
                <div className="tw-bg-teal-dark tw-rounded-2xl tw-p-6 tw-pt-6">
                  <div className="tw-text-white tw-text-center">
                    <h2 className="tw-tracking-tight tw-font-italic tw-text-3xl tw-uppercase xmd:tw-leading-3 tw-mt-4 xmd:tw-leading-3 tw-mb-4">
                      {this.state.data.membership.title[lang]}
                    </h2>
                    <p className="tw-mb-6 mb-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.state.data.membership.description[lang]) }}/>
                  </div>
                  <Slider
                    className="tw-pt-3 xmd:tw-hidden"
                    viewportClassName="tw-overflow-visible"
                    innerClassName="tw-space-x-2"
                    // spacerClassName="w-3"
                  >
                    {this.state.data.membership.items[lang].map((props, index) => {
                      return (
                        <SliderItemMember
                          className="tw-w-full" 
                          key={"slider_membership_" + index}
                          {...props}
                          lang={lang}
                        />
                      );
                    })}
                  </Slider>
                  <div className="tw-hidden xmd:tw-flex xmd:tw-gap-2">
                    {this.state.data.membership.items[lang].map((props, index) => {
                      return (
                        <SliderItemMember
                          className="tw-flex-1"
                          key={"slider_membership_" + index}
                          {...props}
                          lang={lang}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </Section>
        
          {this.state.isLoaded && (
            <BackgroundImageBox data={this.state.data.image_box} lang={lang} />
          )}

        <Section className="tw-p-5 tw-pb-0 tw-max-w-screen-lg tw-m-auto md:tw-py-5">
          {this.state.isLoaded && (
            <ClubFinder data={this.state.data.studios} lang={lang} />
          )}
        </Section>

        <Section className="tw-overflow-hidden">
          {(this.state.isLoaded && this.state.data.info_text) && (
            <div className="tw-p-5 tw-max-w-screen-lg tw-m-auto">
              <div className="tw-bg-teal tw-rounded-2xl tw-px-6 tw-py-12">
                <div className="tw-text-white tw-text-center">
                    <h2 className="tw-tracking-tight tw-font-italic tw-text-3xl tw-uppercase xmd:tw-leading-3 tw-mt-2 xmd:tw-leading-3 tw-mb-8">
                      {this.state.data.info_text['title_'+lang]}
                    </h2>
                    <p className="tw-mb-6 mb-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.state.data.info_text['text_'+lang]) }}/>
                    <div className="tw-text-center">
                      <Button
                        className="tw-mt-0 active:tw-border-transparent"
                        color="white"
                        size="small"
                        title={this.state.data.info_text['button_'+lang].text}
                        href={this.state.data.info_text['button_'+lang].url}
                      />
                    </div>
                </div>
              </div>
            </div>
          )}
        </Section>



        <Section className="tw-px-5 tw-pt-5 tw-pb-8 tw-max-w-screen-lg tw-m-auto sm:tw-bg-white tw-bg-gray-light image-grid">
          {/*this.state.isLoaded && (
            <Heading
              className="tw-pb-5 tw-pt-7 tw-max-w-screen-lg tw-m-auto"
              headlineClassNames="xmd:tw-leading-3" // Hier
              title={this.state.data.offers.title[lang]}
              subtitle={this.state.data.offers.subtitle[lang]}
            />
          )*/}
            <div className="tw-text-center">
              <h2 className="tw-tracking-tight tw-text-teal tw-font-normal tw-text-3xl tw-uppercase tw-leading-7 md:tw-leading-3 tw-mt-4" style={{wordBreak: "keep-all"}}>
                {this.state.isLoaded && (this.state.data.offers.title[lang])}
              </h2>
              <p className="tw-font-black tw-font-italic tw-text-md tw-uppercase tw-leading-4 tw-mt-2">{this.state.isLoaded && (this.state.data.offers.subtitle[lang])}</p>
              <br/>
            </div>
            <div className="tw-inline-block tw-gap-2 md:tw-gap-2.5 tw-grid-cols-3 tw-grid-rows-2 tw-grid-cols-2 tw-w-full">
              <div className="tw-col-start-1 tw-col-end-3 tw-float-left tw-aspect-[4/3] tw-w-2/4 tw-pr-1 tw-pb-1">
                {this.state.isLoaded && (
                  <Picture
                    classNameOuter="tw-aspect-[4/3]"
                    className="tw-object-cover tw-rounded-xl lg:tw-rounded-2xl tw-aspect-[4/3]"
                    src={gridImages[0][0]}
                    sources={gridImages[0][1]}
                    options={ {width: '485', height: '355'}}
                  />
                )}
              </div>
              <div className="long tw-col-start-3 tw-col-end-4 tw-float-left tw-aspect-[16/6] tw-w-2/4 tw-pl-1 tw-pb-1">
                {this.state.isLoaded && (
                  <Picture
                    classNameOuter="tw-aspect-[16/6]"
                    className="tw-aspect-[16/6] tw-object-cover tw-rounded-xl lg:tw-rounded-2xl"
                    src={gridImages[1][0]}
                    sources={gridImages[1][1]}
                    options={ {width: '485', height: '175'}}
                  />
                )}
              </div>
              <div className="tw-col-start-1 tw-col-end-2 tw-float-right tw-aspect-[4/3] tw-w-2/4 tw-pl-1 tw-pt-1">
                {this.state.isLoaded && (
                  <Picture
                    classNameOuter="tw-aspect-[4/3]"
                    className="tw-object-cover tw-aspect-[4/3] tw-rounded-xl lg:tw-rounded-2xl"
                    src={gridImages[2][0]}
                    sources={gridImages[2][1]}
                    options={ {width: '485', height: '355'}}
                  />
                )}
              </div>
              <div className="tw-col-start-2 tw-col-end-4 tw-float-left tw-aspect-[16/6] tw-w-2/4 tw-pr-1 tw-pt-1">
                {this.state.isLoaded && (
                  <Picture
                    classNameOuter="tw-aspect-[16/6]"
                    className="tw-aspect-[16/6] tw-object-cover tw-rounded-xl lg:tw-rounded-2xl"
                    src={gridImages[3][0]}
                    sources={gridImages[3][1]}
                    options={ {width: '485', height: '175'}}
                  />
                )}
              </div>
            </div>

            {this.state.isLoaded && (
              <div className="tw-text-center">
                <Button
                  className="tw-mt-8 tw-w-full md:tw-w-auto lg:tw-mt-12"
                  color="teal"
                  title={this.state.data.offers.offersLink[lang].label}
                  href={this.state.data.offers.offersLink[lang].href}
                />
              </div>
            )}
        </Section>

        <Section>
          {this.state.isLoaded && (
            <>
              <Heading
                title={this.state.data.teaser.title[lang]}
                subtitle={this.state.data.teaser.subtitle[lang]}
                className="tw-pt-2 sm:tw--mb-4 lg:tw-mb-0"
              />

              <div className="md:tw-flex lg:tw-flex-wrap lg:tw-mt-8 lg:tw-mb-2 md:tw-max-w-screen-lg md:tw-m-auto">
                {this.state.data.teaser.items[lang].map((props, index) => {
                  return (
                    <Teaser
                      isThird={false}
                      key={"teaser_" + index}
                      index={index}
                      {...props}
                    />
                  );
                })}
              </div>
              <div className="md:tw-flex tw-hidden sm:tw-hidden lg:tw-flex-wrap lg:tw-mt-8 lg:tw-mb-2 md:tw-max-w-screen-lg md:tw-m-auto">
                {this.state.data.teaser.items[lang].map((props, index) => {
                  let third = (index + 1) % 3 === 0;
                  return third ? (
                    <Teaser
                      isThird={true}
                      key={"teaser_" + index}
                      index={index}
                      {...props}
                    />
                  ) : null;
                })}
              </div>
            </>
          )}
        </Section>

        <Section className="tw-overflow-hidden tw-mb-12 item-cites">
            
          {(this.state.isLoaded && this.state.data.members.items && this.state.data.members.items[0].name ) && (
            <div className="tw-p-5 tw-max-w-screen-lg tw-m-auto">
              <div className="tw-rounded-2xl">
                <div className="tw-text-teal tw-mb-8 tw-text-center">
                  <h2 className="tw-tracking-tight tw-font-italic tw-text-3xl tw-uppercase xmd:tw-leading-3 tw-mt-2 xmd:tw-leading-3 tw-mb-16">
                    {this.state.data.members.headline[lang]}
                  </h2>
                 </div>
                <Slider
                  className="tw-pt-3 xmd:tw-hidden slider-cite"
                  viewportClassName="tw-overflow-visible tw-h-cite-mobile"
                  innerClassName="tw-space-x-2 tw-flex"
                  // spacerClassName="w-3"
                >
                  {this.state.data.members.items.map((props, index) => {
                    return (
                      <SliderItemCite
                        className="tw-w-full" 
                        key={"slider_cite_" + index}
                        {...props}
                        lang={lang}
                        sliderBG={index}
                      />
                    );
                  })}
                </Slider>
                <div className="tw-hidden xmd:tw-flex xmd:tw-gap-2">
                  {this.state.data.members.items.map((props, index) => {
                    return (
                      <SliderItemCite
                        className="tw-flex-1"
                        key={"slider_cite_" + index}
                        {...props}
                        lang={lang}
                        sliderBG={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </Section>
      </>
    );
  }
}
PageStart.contextType = EnvContext;

export default PageStart;
